export const SET_REMUNERATIONS = 'SET_REMUNERATIONS';
export const RECORD_PAYMENT = 'RECORD_PAYMENT';
